<template>
  <div :class="{ 'c-dark-theme': $store.state.darkMode }">
    <CCard :style="tankCardStyle(450, 500)" :border-color="signalVariant(signalColor)">

      <CCardHeader>
        <TankCardHeader :tank="tank"
                        :signal-color="signalColor"
                        :status-variant="statusVariant"
                        :status-msg="statusMsg"
                        :last-dt="lastDt"
                        :inout="inout"
                        :show-inout="tank.tankUse==='1' || tank.tankUse==='2'"
                        @inout="setInout">
          <template #units>
            <TankUnitBadges :vol-unit="volUnit" :len-unit="lenUnit" :tmp-unit="tmpUnit"
                            @toggle-vol="toggleVolUnit" @toggle-len="toggleLenUnit" @toggle-tmp="toggleTmpUnit"/>
          </template>
          <!-- 급유차 형태에서만 급유 대상 기종/기번을 함께 보여준다 -->
          <template #actions>
            <CCol v-if="tank.tankShape==='4' && inout.sts!=='N'">
              <CBadge color="secondary" class="mr-1"> 기종 </CBadge> {{inout.eqnm}}
              <CBadge color="secondary" class="ml-2 mr-1"> 기번 </CBadge> {{inout.eqid}}
            </CCol>
          </template>
        </TankCardHeader>
      </CCardHeader>

      <CCardBody>



      <!-- 입출고 표시는 탱크 캔버스 위에 겹쳐 띄운다 (position-relative 필요) -->
      <CRow>

        <!-- canvas -->
        <!--
          cols 7:5 로 캔버스 쪽을 넓혀 탱크를 카드 가운데에 가깝게 둔다.
          우측 상세표는 폭 120px 고정이라 5칸으로도 남는다.
          오버레이는 절대배치라 탱크는 항상 이 칼럼 한가운데 고정된다.
        -->
        <!--
          탱크는 칼럼 가운데 정렬한다. 오른쪽 끝에 붙였더니 위쪽 오버레이 상자와
          중심이 어긋나 오히려 치우쳐 보였다.
          카드 전체 기준으로는 상세표(164px) 때문에 완전한 중앙이 될 수 없어,
          왼쪽 여백을 조금 더 줘서 가운데 쪽으로 밀어 준다(값만 바꾸면 조절된다).
          여백 값을 바꿔도 오버레이가 같이 따라오도록 기준 상자는 안쪽 div 로 둔다.
        -->
        <!--
          칼럼에는 세로 정렬을 주지 않는다. 안쪽 div 가 칼럼 높이만큼 늘어나야
          오버레이(top:0)가 칼럼 맨 위에 붙는다. 종전에는 칼럼이 가운데 정렬이라
          안쪽 div 가 탱크 높이만큼만 차지해 오버레이도 그만큼 내려와 있었다.
        -->
        <CCol col="7"
              class="d-flex"
              style="padding-left: 2.75rem">
          <!--
            오버레이의 기준 상자를 이 안쪽 div 로 둔다.
            칼럼에 직접 position-relative 를 주면 절대배치의 기준이 padding box 라
            왼쪽 여백(2.75rem)을 무시하고 칼럼 전체에 걸쳐, 여백만큼 탱크와
            중심이 어긋났다. 여백 안쪽을 기준으로 삼아 탱크와 같은 축에 맞춘다.
            탱크는 이 div 안에서 가운데 정렬한다.
          -->
          <div class="position-relative w-100 d-flex align-items-center justify-content-center">
            <!-- 발생한 경보 배지. 탱크 오른쪽 가운데(컨테이너 오른쪽 끝)에서 세로로 쌓아 표시한다 -->
            <WidgetEvents ref="evtWidget" vertical class="position-absolute evt-overlay"
                          :style="{ top: '50%', transform: 'translateY(-50%)', right: '0.25rem', zIndex: 11 }"/>
            <!-- 충족률. 탱크 그림 왼쪽 아래에 레이어로 표시 (상단 버튼 그룹에서 옮김) -->
            <div class="tvp-overlay" :class="{'font-lg': $store.state.largeFont}">{{ comma(pk.tvp, 0) }} %</div>
            <InoutProgress :inout="inout"
                           :vol-percent="volPercent"
                           :diff-ovm="diffOvm"
                           :diff-ovc="diffOvc"
                           :vol-unit="volUnit"
                           :target-vol.sync="inputTargetVol"
                           :show-target="tank.tankShape!=='4'"
                           :placeholder-text="`목표량(${tankUnitSign(volUnit)})입력`"
                           @save="setInoutVolume"
                           @clear="setInout('N')">
              <!-- 급유차(tankShape 4)의 인증번호는 표의 한 행으로 붙인다 -->
              <template #append>
                <tr v-if="tank.tankShape==='4' && pk.fcd==='04'">
                  <td class="io-label">인증#</td>
                  <td class="text-right">{{ inout.ano }}</td>
                </tr>
              </template>
            </InoutProgress>

            <canvas
              width="150"
              height="170"
              ref="canvas"
            >
            </canvas>
          </div>
        </CCol>

        <CCol col="5">
          <TankDetailTable :pk="pk"
                            :tank="tank"
                            :status="status"
                            :vol-unit="volUnit"
                            :len-unit="lenUnit"
                            :tmp-unit="tmpUnit"
                            show-vacancy
                            @toggle-detail="toggleDetail"/>
        </CCol>
      </CRow>
      <TankTempTable v-show="detailTmShow" :pk="pk" :tmp-unit="tmpUnit" :tm-use-map="tmUseMap"/>
      </CCardBody>
    </CCard>
  </div>
</template>

<style>
.tooltip .tooltip-inner {
  text-align: left;
  max-width: 350px !important;
  width: 250px !important;
}

@keyframes blink-effect {
  50% {
    opacity: 0;
  }
}

.blink {
  animation: blink-effect 1s step-end infinite;

  /*
  animation-name: blink-effect;
  animation-duration: 1s;
  animation-iteration-count:infinite;
  animation-timing-function:step-end;
  */
}
</style>

<script>
//------------------------------------------------------------------------
// import '../../common/HelperMixin';
import WidgetEvents from '../widget/WidgetEvents'
import InoutStatusMixin from '@/common/inout-status-mixin'
import InoutProgress from './InoutProgress'
import TankCardHeader from './TankCardHeader'
import TankDetailTable from './TankDetailTable'
import TankUnitBadges from './TankUnitBadges'
import TankTempTable from './TankTempTable'
import {fabric} from 'fabric';

// 실린더형(2·4·73) 앞면 이미지는 모드별로 두 장, 뒷면(내부) 이미지는 다크용 한 장뿐이다.
// 라이트 모드에서는 뒷면에 밝기 필터를 얹어 내부를 밝힌다 (applyBackTheme)
const CYL_FRONT_IMG = {
  dark:  "/img/tank/CYLINDER_n130-black-new1.png",
  light: "/img/tank/CYLINDER_n130-white-new1.png",
};
const CYL_BACK_BRIGHTNESS = 0.45; // 라이트 모드 뒷면 밝기 보정 (0~1, 클수록 밝다)
// import moment from 'moment';
import {
  getR,
  clone,
  comma,
  trans,
  apiCall,
  unitSign,
  speech,
  sleep,
  getDiffMinute,
  ltrToUnit,
  unitToLtr,
  tankUnitSign
} from "@/common/utils";
import {PacketSchema} from "@/common/schema";
import {IoStsMap} from '@/common/constants';
import moment from "moment";
// import {callback} from "chart.js/helpers";


const _normalBadge = {'1':'dark', '2':'dark', '3':'dark', '4':'dark', '5':'dark', '6':'dark', '7':'dark', '8':'dark', '9':'dark'};
// const GL2LTR = 3.78541;

export default {
  name: "Tank2D",
  components: {
    WidgetEvents,
    InoutProgress,
    TankCardHeader,
    TankDetailTable,
    TankUnitBadges,
    TankTempTable
  },
  mixins: [InoutStatusMixin],
  props: {
    width: {type: Number, default: 300},
    height: {type: Number, default: 200},
    tank: { type: Object, default: null },
    bgColor: { type: String, default: '#FFFFFF'},
    tlgPacket : { type: Object, default: null },
    initPacket : { type: Object, default: null }
  },
// °C, °F , ㎜, in, gal ====> C,F,mm,in,gal
  data () {
    return {
      lastDt: '',
      tankSts: { io: '', ioAt: null },
      canvas: null,
      windowHeight: 0,
      windowWidth: 0,

      detailTmShow: false,

      eventKey: 0,

      tid: '',
      tnm: '',
      inout: { sts: 'N' },

      events: {data: [], dt: null},
      // eventTip: {},
      // eventLogs: [],
      trans: trans,
      unitSign: unitSign,
      tankUnitSign: tankUnitSign,
      volUnit: 'g', // l <--> g
      lenUnit: 'i', // mm <--> i
      tmpUnit: 'f', // c <---> f
      comma: comma,
      // 1-넘침,2-부족,3-화재,4-수분,5-누유,6-넘침2,7-부족2,8-센서오류,9-패킷오류
      eventColor: {
        '1':'warning',
        '2':'warning',
        '3':'danger',
        '4':'info',
        '5':'danger',
        '6':'danger',
        '7':'danger',
        '8':'info',
        '9':'warning'
      },
      badgeColor: clone(_normalBadge),
      tmUseMap: {
        'tm1': false,
        'tm2': false,
        'tm3': false,
        'tm4': false,
        'tm5': false,
        'tm6': false,
      },

      status: 'off', // norm, warn, info, off
      signalColor: 'dark',
      pk: clone(PacketSchema),
      w: 400,
      h: 250,
      cube: null,

      isPacketFirst: true,
      isCamMoved: false,

      controls: null,

      oilColors: this.$store.state.codeMaps['OIL_COLOR'],
      nozSizeMap: this.$store.state.codeMaps['NOZ_SIZE'],
      shapeMap: this.$store.state.codeMaps['TANK_SHAPE'],
      eventCodeMap: this.$store.state.codeMaps['EVENT'],
      alarmCfg: this.$store.state.alarm,

      machine: null,
      tankColor: null,
      oilColor: null,

      tankOpenAngle: getR(45),
      tankCloseAngle: getR(280),

      oilTopEllipse: null,
      oilBottomEllipse: null,
      waterTopEllipse: null,
      waterBottomEllipse: null,
      oilRect: null,
      waterRect: null,
      tankFront: null,
      tankBack: null,
      safetyLine: null, // 적정재고량(안전재고) 점선
      oilTopRim: null,  // 유면 상단 원판 앞쪽 경계선


      oilVol: 0,
      wtrVol: 0,
      inputTargetVol: null,
      widgetInstance: null
    }

  },
  created(){
    // console.warn("[Tank2D] --------------created------------- shape = ", this.tank.tankShape);
    this.volUnit = this.tank.unitOfVol?this.tank.unitOfVol:'l'
    this.lenUnit = this.tank.unitOfLen?this.tank.unitOfLen:'mm'
    this.tmpUnit = this.tank.unitOfTmp?this.tank.unitOfTmp:'c'


  },

  async mounted() {
    try{
      this.w = this.width;
      this.h = this.height;

      this.isPacketFirst = true;
      this.isCamMoved = false;

      if( this.tank ) {
        this.tid = this.tank.tid;
        this.tnm = this.tank.name;

        this.oilColor = this.oilColors[this.tank.oilCode];
        await this.init(this.tank);

        await this.getInout();
        await this.getTankSts();
      }
      this.oilVol = this.tank.tankRealVol;

      await sleep(1000);

      if( Array.isArray( this.$refs['evtWidget'] ) ) {
        this.widgetInstance = this.$refs['evtWidget'][0];
      } else {
        this.widgetInstance = this.$refs['evtWidget'];
      }

    }catch(err){
      console.error(err);
    }

  },

  methods: {



    async init(tank){
      // console.log( "init tank ----------->", tank );
      const canvas = new fabric.Canvas( this.$refs.canvas );
      this.canvas = canvas;

      let oilVol = 0;
      let wtrVol = 0;

      // 최근 탱크 재고
      try{
        const r = await apiCall('get', `/api/tank/latest-packet/${this.tank.tid}`);
        if(r.code===200 && r.result ){
          this.pk = r.result;
          oilVol = r.result.ovm;
          wtrVol = r.result.wv;
          this.lastDt = this.toHumanTime( getDiffMinute( moment(r.result.dt), moment() )) + ' 전';
          // console.log( 'tid =', this.tank.tid, 'oilVol =', oilVol, 'diff-sec =', getDiffMinute( moment(r.result.dt), moment() ) );
        }
      }catch(err){
        console.error(err);
      }

      //탱크 유량 및 수분량 설정
      let oilHeight = oilVol / tank.tankVolume * 100;
      let waterHeight = wtrVol / tank.tankVolume * 100;

      let sumHeight =  oilHeight + waterHeight;

      let oilTop = 157 - sumHeight;
      let waterTop = oilTop + oilHeight;

      let oilEllipseY = 10;
      let waterEllipseTopY = 0;
      let waterEllipseBottomY = 10;

      //유량 및 수분량이 0일때 처리
      if(oilHeight === 0) { oilEllipseY = 0; waterEllipseTopY = 10; }
      if(waterHeight === 0) { waterEllipseTopY = 0; waterEllipseBottomY = 0; }

      // 누운 실린더형은 수면이 옆에서 보이므로 상·하단 캡 타원(원반)을 접어 평평하게 그린다
      if( this.isLaidCylinder() ){ oilEllipseY = 0; waterEllipseTopY = 0; waterEllipseBottomY = 0; }


      //탱크종류별 이미지 설정

      const leftLocation = 16;

      // 유량 도형은 패킷마다 새로 만들기 때문에 fabric 객체 캐시를 끈다(objectCaching:false).
      // 캐시를 켜두면 객체마다 오프스크린 <canvas>가 하나씩 생겨, 탱크 5기 기준으로
      // 초당 12개꼴로 캔버스가 할당됐다(12시간이면 50만개 규모). 단순 도형이라 캐시 이득도 없다.
      // 오일 Rect
      this.oilRect = new fabric.Rect({
        left: leftLocation,
        top: oilTop,       //최소 157, 최대 57
        fill: this.oilColor, // 패킷 갱신(renderVolume)과 같은 유종색으로 처음부터 그린다
        width: 105,
        height: oilHeight,
        opacity: 0.8,
        selectable: false,
        objectCaching: false
      });

      // 오일 상단
      this.oilTopEllipse = new fabric.Ellipse({
        left: leftLocation,
        top: oilTop - 10,       //최소 147, 최대 47
        //fill: oilColor,
        rx: 52.5,
        ry: oilEllipseY,
        opacity: 0.9,
        selectable: false,
        objectCaching: false
      });


      this.oilTopEllipse.set('fill', new fabric.Gradient({
        coords: {
          x1: 0,
          y1: -1*this.oilTopEllipse.height / 5,
          x2: 0,
          y2: -1*this.oilTopEllipse.height * 1.5,
        },
        colorStops: [
          { offset: 0.3, color: this.oilColor },
          { offset: 1,  color: '#ddd'}
        ]
      })
      );


      // 오일 하단
      this.oilBottomEllipse = new fabric.Ellipse({
        left: leftLocation,
        top: waterTop - 10,       //최소 147, 최대 47
        fill: this.oilColor,
        rx: 52.5,
        ry: oilEllipseY,
        opacity: 0.9,
        selectable: false,
        objectCaching: false
      });

      // 수분 하단
      this.waterBottomEllipse = new fabric.Ellipse({
        left: leftLocation,
        top: 147,       //최소 147, 최대 47
        fill: '#367DB0',
        rx: 52.5,
        ry: waterEllipseBottomY,
        opacity: 0.9,
        selectable: false,
        objectCaching: false
      });


      // 수분 상단
      this.waterTopEllipse = new fabric.Ellipse({
        left: leftLocation,
        top: waterTop - 10,       //최소 147, 최대 47
        fill: '#367DB0',
        rx: 52.5,
        ry: waterEllipseTopY,
        opacity: 0.9,
        selectable: false,
        objectCaching: false
      });


      this.waterTopEllipse.set( 'fill',  new fabric.Gradient( {
        // type: 'linear',
        // gradientUnits: 'pixels',
        coords: {
          x1: 0,
          y1: -1 * this.waterTopEllipse.height / 5,
          x2: 0,
          y2: -1 * this.waterTopEllipse.height * 1.5,
        },
        colorStops: [
          { offset: 0.3, color: '#367DB0' },
          { offset: 1, color:'#ddd'}
        ]
      }));


      // 수분 Rect
      this.waterRect = new fabric.Rect({
        left: leftLocation,
        top: waterTop,       //최소 157, 최대 57
        fill: '#367DB0',
        width: 105,
        height: waterHeight,
        opacity: 0.9,
        selectable: false,
        objectCaching: false
      });

      const waterBottomEllipse = this.waterBottomEllipse;
      const waterRect = this.waterRect;
      const waterTopEllipse = this.waterTopEllipse;
      const oilBottomEllipse = this.oilBottomEllipse;
      const oilRect = this.oilRect;
      const oilTopEllipse = this.oilTopEllipse;
      let bgImageBack = '';
      let bgImageFront = '';
      // let backImg;

      if( tank.tankShape === '2' || tank.tankShape === '4' || tank.tankShape === '73' ) {
        // Cylinder, TankLorry
        bgImageBack =  "/img/tank/CYLINDER_n130_b-black.png";
        bgImageFront = this.$store.state.darkMode ? CYL_FRONT_IMG.dark : CYL_FRONT_IMG.light;
      }else{
        // Exclusive, ConeRoof
        bgImageBack =  "/img/tank/EXCLUSIVE2_n130_b.png";
        bgImageFront = "/img/tank/EXCLUSIVE2_n130.png";
      }


      // 탱크 back 이미지 호출

      let tankBack = await this.imageFromUrl( bgImageBack );

      // 이미지를 기다리는 사이에 화면을 벗어나면 캔버스는 이미 dispose 된 상태다.
      // 여기서 멈추지 않으면 정리된 캔버스에 도형을 다시 붙여 그대로 남는다.
      if( !this.canvas ) return;

      tankBack.top = 20;
      tankBack.left = 10;
      tankBack.selectable = false;
      this.tankBack = tankBack;
      this.applyBackTheme( tankBack );

      canvas.add(tankBack);
      canvas.add(waterBottomEllipse);
      canvas.add(waterRect);
      canvas.add(waterTopEllipse);
      canvas.add(oilBottomEllipse);
      canvas.add(oilRect);
      canvas.add(oilTopEllipse);

      this.oilTopRim = this.makeOilTopRim( oilTop, oilEllipseY, oilHeight );
      if( this.oilTopRim ) canvas.add( this.oilTopRim );

      const tankFront = await this.imageFromUrl( bgImageFront );
      if( !this.canvas ) return;

      // 안전재고 점선은 탱크 표면(front 이미지) 뒤에 깔리도록 front 보다 먼저 올린다
      this.drawSafetyLine( canvas );

      this.tankFront = tankFront;
      this.tankFront.top = 20;
      this.tankFront.left = 10;
      canvas.add(this.tankFront);

      /*
      fabric.Image.fromURL( bgImageBack, function(oImg) {

        oImg.top = 20;
        oImg.left = 10;
        oImg.selectable = false;
        backImg = oImg;
        // 탱크 front 이미지 호출 및 캔버스 렌더링
        fabric.Image.fromURL( bgImageFront, function(oImg) {
          oImg.top = 20;
          oImg.left = 10;
          oImg.selectable = false;

          canvas.add(backImg);
          canvas.add(waterBottomEllipse);
          canvas.add(waterRect);
          canvas.add(waterTopEllipse);
          canvas.add(oilBottomEllipse);
          canvas.add(oilRect);
          canvas.add(oilTopEllipse);
          canvas.add(oImg);

        });
      });

       */
    },

    /**
     * 적정재고량(안전재고) 표시선. 탱크에 붉은 점선으로 그린다.
     * 유면 타원(rx 52.5, ry 10)과 같은 곡률의 점선 타원 링으로 그려
     * 원통을 두르는 것처럼 입체감을 준다.
     * 부피→높이는 총용량 대비 선형 근사다(유량 도형과 같은 방식).
     */
    drawSafetyLine( canvas ){
      const safetyVol = Number(this.tank?.safetyVolume) || 0;
      if( !(safetyVol > 0 && this.tank.tankVolume > 0) ) return;

      const h = Math.min( 100, safetyVol / this.tank.tankVolume * 100 );
      const y = 157 - h;       // 안전재고 유위(타원 중심)
      const cx = 68.5;         // 유량 도형 중심 x
      const rx = 54, ry = 10;  // 유면 타원(52.5)보다 살짝 크게 둘러싼다

      // 옆으로 누운 실린더형(2:실린더, 4:급유차, 73)은 수면이 옆에서 보이므로
      // 원판(타원) 대신 수평 수면선으로 그린다
      if( this.isLaidCylinder() ){
        // 은은한 수면 띠 + 선명한 점선
        const glowLine = new fabric.Line([12, y, 128, y], {
          stroke: 'rgba(248,108,107,0.25)', strokeWidth: 4,
          selectable: false, objectCaching: false
        });
        const dashLine = new fabric.Line([12, y, 128, y], {
          stroke: '#f86c6b', strokeWidth: 1, strokeDashArray: [5, 3],
          selectable: false, objectCaching: false
        });
        this.safetyLine = new fabric.Group([glowLine, dashLine], {
          selectable: false, objectCaching: false
        });
        canvas.add( this.safetyLine );
        return;
      }

      // 채움 타원 (테두리 없음). 위쪽을 밝게 빼서 유면 타원과 같은 입체감을 준다
      const fillEllipse = new fabric.Ellipse({
        left: cx - rx, top: y - ry, rx, ry,
        stroke: '', selectable: false, objectCaching: false
      });
      fillEllipse.set('fill', new fabric.Gradient({
        coords: { x1: 0, y1: ry * 2, x2: 0, y2: 0 },
        colorStops: [
          { offset: 0, color: 'rgba(248,108,107,0.45)' },
          { offset: 1, color: 'rgba(255,210,210,0.15)' }
        ]
      }));

      // 뒤쪽(위) 테두리. 원판 안쪽이 멀리 있는 것처럼 흐리게 그린다
      const backArc = new fabric.Path(
        `M ${cx - rx} ${y} A ${rx} ${ry} 0 0 1 ${cx + rx} ${y}`, {
          fill: '', stroke: 'rgba(248,108,107,0.3)', strokeWidth: 1,
          strokeDashArray: [4, 4], selectable: false, objectCaching: false
      });

      // 앞쪽(아래) 테두리. 가까운 쪽이라 선명하게 그린다
      const frontArc = new fabric.Path(
        `M ${cx - rx} ${y} A ${rx} ${ry} 0 0 0 ${cx + rx} ${y}`, {
          fill: '', stroke: '#f86c6b', strokeWidth: 1,
          strokeDashArray: [5, 3], selectable: false, objectCaching: false
      });

      this.safetyLine = new fabric.Group([fillEllipse, backArc, frontArc], {
        selectable: false, objectCaching: false
      });
      canvas.add( this.safetyLine );
    },

    /**
     * 유면 상단 원판의 앞쪽(아래) 호. 가까운 쪽 경계를 진하게 그려 시인성을 높인다.
     * 원판 높이가 패킷마다 달라지므로 renderVolume 에서 다시 만든다.
     * @param oilTop 원판 중심 y
     * @param ry 원판 세로 반지름. 0이면(유량 없음) 그리지 않는다
     */
    makeOilTopRim( oilTop, ry, oilHeight = 0 ){
      // 누운 실린더형은 캡 타원을 접으므로(ry=0) 유량 유무로 판정해 수평 직선을 그린다
      if( this.isLaidCylinder() ){
        if( oilHeight <= 0 ) return null;
        return new fabric.Line([16, oilTop, 121, oilTop], {
          stroke: this.darkenColor( this.oilColor ),
          strokeWidth: 1,
          selectable: false,
          objectCaching: false
        });
      }

      if( ry <= 0 ) return null;
      return new fabric.Path(
        `M 16 ${oilTop} A 52.5 ${ry} 0 0 0 121 ${oilTop}`, {
          fill: '',
          stroke: this.darkenColor( this.oilColor ),
          strokeWidth: 1,
          selectable: false,
          objectCaching: false
      });
    },

    // 옆으로 누운 실린더형(2:실린더, 4:급유차, 73) 여부
    isLaidCylinder(){
      return ['2', '4', '73'].includes( this.tank?.tankShape );
    },

    /**
     * 유종색보다 진한 톤을 만든다 (유면 상단 원판 테두리용)
     * @param color '#RRGGBB' 형식. 아니면 짙은 회색으로 대체한다
     * @param factor 어둡게 할 비율 (0~1, 작을수록 진하다)
     */
    darkenColor( color, factor = 0.55 ){
      const c = String(color || '').replace('#', '');
      if( c.length !== 6 ) return '#333333';
      const d = [0, 2, 4].map( i =>
        Math.round( parseInt(c.substr(i, 2), 16) * factor ).toString(16).padStart(2, '0')
      ).join('');
      return `#${d}`;
    },

    /**
     * 뒷면(내부) 이미지의 모드 보정. 다크용 이미지 한 장뿐이라 라이트 모드에서는
     * 밝기 필터를 얹어 내부가 어둡게 남지 않게 한다. 다크 모드에서는 필터를 뗀다.
     * 실린더형(2·4·73)에만 해당한다 (다른 형은 모드 공용 이미지).
     */
    applyBackTheme(img){
      if( !img ) return;
      if( !this.$store.state.darkMode && this.isLaidCylinder() ){
        img.filters = [ new fabric.Image.filters.Brightness({ brightness: CYL_BACK_BRIGHTNESS }) ];
      }else{
        img.filters = [];
      }
      img.applyFilters();
    },

    /**
     * 다크/라이트 전환 시 이미 그려진 탱크 이미지를 바꿔 그린다 (watch darkMode).
     * 앞면은 모드별 이미지로 교체, 뒷면은 밝기 필터를 켜고 끈다.
     */
    async refreshThemeImages(dark){
      if( !this.canvas || !this.tankBack || !this.tankFront ) return;
      this.applyBackTheme( this.tankBack );
      if( this.isLaidCylinder() ){
        const url = dark ? CYL_FRONT_IMG.dark : CYL_FRONT_IMG.light;
        await new Promise( resolve => this.tankFront.setSrc( url, resolve ) );
        if( !this.canvas ) return; // 이미지를 기다리는 사이 화면을 벗어난 경우
      }
      this.canvas.renderAll();
    },

    imageFromUrl(url) {
      return new Promise( (resolve, reject) => {
        fabric.Image.fromURL(url, (img) => {
          if (!img) reject(null)
          else return resolve(img);
        });
      });
    },


    renderVolume(oilVol, wtrVol){
      const canvas = this.canvas;
      // 정리된 뒤 늦게 들어온 패킷은 버린다 (부모가 소켓 핸들러를 늦게 떼는 경우)
      if( !canvas ) return;
      // if(this.renderer ) this.renderer.render( this.scene, this.camera );


      canvas.remove(this.waterBottomEllipse);
      canvas.remove(this.waterRect);
      canvas.remove(this.waterTopEllipse);
      canvas.remove(this.oilBottomEllipse);
      canvas.remove(this.oilRect);
      canvas.remove(this.oilTopEllipse);
      if( this.oilTopRim ) canvas.remove(this.oilTopRim);

      this.waterBottomEllipse = null;
      this.waterRect = null;
      this.waterTopEllipse = null;
      this.oilBottomEllipse = null;
      this.oilRect = null;
      this.oilTopEllipse = null;
      this.oilTopRim = null;

      //탱크 유량 및 수분량 설정
      let oilHeight = oilVol / this.tank.tankVolume * 100;
      let waterHeight = wtrVol / this.tank.tankVolume * 100;

      let sumHeight =  oilHeight + waterHeight;

      let oilTop = 157 - sumHeight;
      let waterTop = oilTop + oilHeight;

      let oilEllipseY = 10;
      let waterEllipseTopY = 0;
      let waterEllipseBottomY = 10;

      //유량 및 수분량이 0일때 처리
      if(oilHeight === 0) { oilEllipseY = 0; waterEllipseTopY = 10; }
      if(waterHeight === 0) { waterEllipseTopY = 0; waterEllipseBottomY = 0; }

      // 누운 실린더형은 수면이 옆에서 보이므로 상·하단 캡 타원(원반)을 접어 평평하게 그린다
      if( this.isLaidCylinder() ){ oilEllipseY = 0; waterEllipseTopY = 0; waterEllipseBottomY = 0; }


      //탱크종류별 이미지 설정

      const leftLocation = 16;

      // 유량 도형은 패킷마다 새로 만들기 때문에 fabric 객체 캐시를 끈다(objectCaching:false).
      // 캐시를 켜두면 객체마다 오프스크린 <canvas>가 하나씩 생겨, 탱크 5기 기준으로
      // 초당 12개꼴로 캔버스가 할당됐다(12시간이면 50만개 규모). 단순 도형이라 캐시 이득도 없다.
      // 오일 Rect
      this.oilRect = new fabric.Rect({
        left: leftLocation,
        top: oilTop,       //최소 157, 최대 57
        fill: this.oilColor,
        width: 105,
        height: oilHeight,
        opacity: 0.8,
        selectable: false,
        objectCaching: false
      });

      // 오일 상단
      this.oilTopEllipse = new fabric.Ellipse({
        left: leftLocation,
        top: oilTop - 10,       //최소 147, 최대 47
        fill: this.oilColor,
        rx: 52.5,
        ry: oilEllipseY,
        opacity: 0.9,
        selectable: false,
        objectCaching: false
      });

      this.oilTopEllipse.set('fill', new fabric.Gradient({
          coords: {
            x1: 0,
            y1: -1*this.oilTopEllipse.height / 5,
            x2: 0,
            y2: -1*this.oilTopEllipse.height * 1.5,
          },
          colorStops: [
            { offset: 0.3, color: this.oilColor },
            { offset: 1,  color: '#ddd'}
          ]
        })
      );

      // 오일 하단
      this.oilBottomEllipse = new fabric.Ellipse({
        left: leftLocation,
        top: waterTop - 10,       //최소 147, 최대 47
        fill: this.oilColor,
        rx: 52.5,
        ry: oilEllipseY,
        opacity: 0.9,
        selectable: false,
        objectCaching: false
      });

      // 수분 하단
      this.waterBottomEllipse = new fabric.Ellipse({
        left: leftLocation,
        top: 147,       //최소 147, 최대 47
        fill: '#367DB0',
        rx: 52.5,
        ry: waterEllipseBottomY,
        opacity: 0.9,
        selectable: false,
        objectCaching: false
      });

      // 수분 상단
      this.waterTopEllipse = new fabric.Ellipse({
        left: leftLocation,
        top: waterTop - 10,       //최소 147, 최대 47
        fill: '#367DB0',
        rx: 52.5,
        ry: waterEllipseTopY,
        opacity: 0.9,
        selectable: false,
        objectCaching: false
      });

      this.waterTopEllipse.set( 'fill',  new fabric.Gradient( {
        // type: 'linear',
        // gradientUnits: 'pixels',
        coords: {
          x1: 0,
          y1: -1 * this.waterTopEllipse.height / 5,
          x2: 0,
          y2: -1 * this.waterTopEllipse.height * 1.5,
        },
        colorStops: [
          { offset: 0.3, color: '#367DB0' },
          { offset: 1, color:'#ddd'}
        ]
      }));


      // 수분 Rect
      this.waterRect = new fabric.Rect({
        left: leftLocation,
        top: waterTop,       //최소 157, 최대 57
        fill: '#367DB0',
        width: 105,
        height: waterHeight,
        opacity: 0.9,
        selectable: false,
        objectCaching: false
      });

      // const waterBottomEllipse = this.waterBottomEllipse;
      // const waterRect = this.waterRect;
      // const waterTopEllipse = this.waterTopEllipse;
      // const oilBottomEllipse = this.oilBottomEllipse;
      // const oilRect = this.oilRect;
      // const oilTopEllipse = this.oilTopEllipse;


      canvas.add(this.waterBottomEllipse);
      canvas.add(this.waterRect);
      canvas.add(this.waterTopEllipse);
      canvas.add(this.oilBottomEllipse);
      canvas.add(this.oilRect);
      canvas.add(this.oilTopEllipse);

      this.oilTopRim = this.makeOilTopRim( oilTop, oilEllipseY, oilHeight );
      if( this.oilTopRim ) canvas.add( this.oilTopRim );

      this.safetyLine?.bringToFront(); // 안전재고선은 유량 도형 위, 탱크 표면 아래에 유지한다
      this.tankFront.bringToFront();

      /*
      let backImg;
      let bgImageBack = '';
      let bgImageFront = '';


      if( this.tank.tankShape === '2' || this.tank.tankShape === '4' ){
        // Cylinder, tank lorry
        bgImageBack =  "/img/tank/CYLINDER_n130_b-black.png";
        // bgImageFront = "/img/tank/CYLINDER_n130-black-new1.png";
        bgImageFront = this.$store.state.darkMode? "/img/tank/CYLINDER_n130-black-new1.png": "/img/tank/CYLINDER_n130-white-new1.png";
      }else{
        // Exclusive, ConeRoof
        bgImageBack =  "/img/tank/EXCLUSIVE2_n130_b.png";
        bgImageFront = "/img/tank/EXCLUSIVE2_n130.png";
      }


      // 탱크 back 이미지 호출
      fabric.Image.fromURL( bgImageBack, function(oImg) {
        oImg.top = 20;
        oImg.left = 10;
        oImg.selectable = false;
        backImg = oImg;

        // 탱크 front 이미지 호출 및 캔버스 렌더링
        fabric.Image.fromURL( bgImageFront, function(oImg) {
          oImg.top = 20;
          oImg.left = 10;
          oImg.selectable = false;

          canvas.add(backImg);
          canvas.add(waterBottomEllipse);
          canvas.add(waterRect);
          canvas.add(waterTopEllipse);
          canvas.add(oilBottomEllipse);
          canvas.add(oilRect);
          canvas.add(oilTopEllipse);
          canvas.add(oImg);
        });
      });

 */
    },

    /**
     * call from outside component
     * @param data
     */
    setVolume(data){
      try {
        const tp = data.payload;

        this.pk = tp;
        this.lastDt = this.toOnlyTime(tp.dt);


        this.badgeColor = {'1':'dark', '2':'dark', '3':'dark', '4':'dark', '5':'dark', '6':'dark', '7':'dark', '8':'dark', '9':'dark'};
        this.status = 'on'

        if (tp.isEvt || tp.isErr) {
          this.status = 'warn';
          this.signalColor = tp.isErr ? 'danger' : 'warning';
          this.events.data = tp.events;
          this.events.dt = tp.dt;
        }else{
          this.events.data = [];
          this.events.dt = tp.dt;
          this.signalColor = 'info';
        }

        // console.log( this.$refs );

        this.widgetInstance?.setEvents(this.events);

        // this.eventKey = random(1,1000000);
        // console.log( '----- signalColor ------------> ', tp );

        this.renderVolume(tp.ovm, tp.wv);

        this.setTankStatus( tp.sts );

        if( tp.sts.io!=='F' ){
          this.applyInoutSts( data.inout );
        }
        this.checkVolumeDown( tp ); // 입출고 없이 재고가 줄면 상태 뱃지를 유량감소로 덮는다

        // 패킷 수신 표시(카드 테두리 색)를 2.5초 유지한 뒤 되돌린다
        setTimeout(() => {
          this.signalColor = "dark"
        }, 2500);

        tp.useTms.map(i=>{
          const tmKey = 'tm'+i;
          this.tmUseMap[tmKey] = true;
          // setTimeout( ()=>{  this.tmUseMap[tmKey] = true; }, i*30 );
          setTimeout( ()=>{  this.tmUseMap[tmKey] = false; }, 3000+(i*30) );
        })



      }catch(err){
        console.error(err);
      }
    },

    setTankStatus(sts){
      this.tankSts = sts;
      this.sts = sts.io;
      this.applyTankSts(sts); // 라벨/색은 공통 로직(inout-status-mixin)
    },


    async getInout(){
      const rs = await apiCall('get', `/api/inout/current/${this.tank.tid}`);
      if(rs.code===200){
        this.inout = rs.result;
        if( this.inout.sts!=='N') this.inputTargetVol = Math.round( ltrToUnit(this.inout.targetVol, this.volUnit) );
        // console.log( 'inout result -----> tid=',this.tid,'--->', rs.result  );
      }
      // await this.toastInfo(`입출고 상태 정보 업데이트`, 'info');
    },

    async getTankSts(){
      const rs = await apiCall('get', `/api/tank/status/${this.tank.tid}`);
      if(rs.code===200){
        this.tankSts = rs.result?rs.result: { io: 'N', ioAt: null };
        const {io} = this.tankSts;

        if( io==='I' || io==='O' ) {
          this.inputTargetVol = Math.round( ltrToUnit(this.inout.targetVol, this.volUnit) );
        }

        // console.log( 'tank status result -----> tid=',this.tid,'--->', rs.result  );
      }
      // await this.toastInfo(`입출고 상태 정보 업데이트`, 'info');
    },



    async setInout( gbn ){
      let cmd = 'B';
      let cmdName = '시작';
      try{

        let inoutStr = IoStsMap[gbn];

        if(gbn==='N'){
          if( !await this.confirmModal(`${this.tnm} ${inoutStr} 작업 취소 확인`, `${inoutStr} 작업 취소`) ) return;
          cmd = 'C';
          cmdName = '취소'
        }else if(this.inout?.sts!=='N') {
          cmd = 'E'
          cmdName = '종료';
        }

        const param = {
          reqSts: gbn,
          cmd: cmd
        }
        // console.log( 'setInout sts --->', gbn, param )

        const rs = await apiCall('post', `/api/inout/${this.tank.tid}`, param);
        // console.log( 'inout result ---------->', rs.result  );
        if(rs.code===200){
          this.inout = rs.result;
          // this.inputTargetVol = 0;
          if( gbn==='I' ) this.inputTargetVol = Math.floor( ltrToUnit(this.pk.vf, this.volUnit) );
          else if( gbn==='O') this.inputTargetVol = Math.floor( ltrToUnit(this.pk.ovm, this.volUnit) );

          this.applyInoutSts(this.inout);

          const msg = `${this.tnm}, ${inoutStr} ${cmdName}, 설정 완료`;
          await this.toastInfo(msg , '경고');
          speech(msg);

        }else{
          // console.log( rs.message );
          await this.toastWarn(rs.message, '경고');
        }
      }catch(err){
        console.error(err);
        await this.toastError(err);
      }
    },

    async setInoutVolume(){
      try{

        const gbn = this.inout.sts;
        if(!this.inputTargetVol){
          return await this.toastInfo('기준량 입력 오류 ', '경고');
        }

        const inoutStr = (gbn==='I')? '입고':'출고';
        const unitStr = `${unitSign(this.volUnit)} 단위로`;

        const targetVol = Number(this.inputTargetVol);

        const param = {
          cmd : 'V',
          reqSts: gbn,
          volume: unitToLtr(targetVol, this.volUnit),
          unit: 'l' // 선택 단위를 리터로 환산해 보낸다 (서버는 l/g 만 해석)
        }

        // console.log( 'setInout sts --->', gbn, param )
        const rs = await apiCall('post', `/api/inout/${this.tank.tid}`, param);
        // console.log( 'inout result ', rs.result  );

        if(rs.code===200){
          this.inout = rs.result;
          this.applyInoutSts(this.inout);
          const msg = `탱크 ${this.tnm}, ${inoutStr} 작업 기준량, ${this.inputTargetVol} ${unitStr} 설정 되었습니다.`;
          await this.toastInfo(msg, '경고');
          speech(msg)
        }else{
          // console.log( rs.message );
          await this.toastWarn(rs.message, '경고');
        }

      }catch(err){
        console.error(err);
      }
    },


    /** 온도센서 표 펼치기/닫기 (평균온도 라벨 클릭) */
    toggleDetail(){
      this.detailTmShow = !this.detailTmShow;
    },

    // 상단 단위 배지 클릭: 해당 단위만 전환
    toggleVolUnit(){
      // L → kL → 드럼(D, 200L) → gal → L 순환
      const order = ['l', 'k', 'd', 'g'];
      this.volUnit = order[ (order.indexOf(this.volUnit) + 1) % order.length ];
      // 진행 중인 입출고 목표량 입력값도 새 단위로 다시 표시
      if( this.inout && this.inout.sts && this.inout.sts !== 'N' && this.inout.targetVol ){
        this.inputTargetVol = Math.round( ltrToUnit(this.inout.targetVol, this.volUnit) );
      }
    },
    toggleLenUnit(){ this.lenUnit = (this.lenUnit === 'mm') ? 'i' : 'mm'; },
    toggleTmpUnit(){ this.tmpUnit = (this.tmpUnit === 'c') ? 'f' : 'c'; },

    /**
     * 컴포넌트 소멸 시 fabric 캔버스를 정리한다.
     *
     * fabric.Canvas 는 생성될 때 window 에 resize 리스너를 건다. 이걸 떼는 건
     * dispose() 뿐이라, 부르지 않으면 window(GC 루트)가 죽은 캔버스를 계속 잡고 있고
     * 캔버스는 다시 이 컴포넌트와 탱크 이미지까지 물고 있어 화면을 오갈 때마다 쌓였다.
     * (Tank3D / Tank3DV2 / TankLorry 는 destroyObjects() 로 정리하는데 여기만 빠져 있었다)
     */
    destroyCanvas(){
      try{
        if(this.canvas) this.canvas.dispose();
      }catch(err){
        console.error(err);
      }
      this.canvas = null;
      this.oilRect = null;
      this.waterRect = null;
      this.oilTopEllipse = null;
      this.oilBottomEllipse = null;
      this.waterTopEllipse = null;
      this.waterBottomEllipse = null;
      this.tankFront = null;
      this.safetyLine = null;
      this.oilTopRim = null;
      this.widgetInstance = null;
    },

  },

  watch:{
    // 헤더 토글로 모드가 바뀌면 이미 그려진 탱크 이미지도 따라 바꾼다
    '$store.state.darkMode'(dark){
      this.refreshThemeImages(dark);
    },
  },
  beforeDestroy(){
    this.destroyCanvas();
  },



}
</script>
